//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 45px 30px;
`;
export const Content = styled.section`
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
`;
export const Footer = styled.footer`
    display: flex;
    justify-content: center;
    gap: 15px;
`;